import { 
    EOIScreens, 
    ExpressionOfInterestState 
} from "@/components/Eoi/eoi.types";
import { 
    createSlice, 
    PayloadAction 
} from "@reduxjs/toolkit";

const initialExpressionOfInterest: ExpressionOfInterestState = {
    currentPage: EOIScreens.PROJECT_LISTING,
    selectedProject: null,
    allProjects: []
};

const expressionOfInterestSlice = createSlice({
    name: "expressionOfInterestReducer",
    initialState: { ...initialExpressionOfInterest },
    reducers: {
        setExpressionOfInterest: (state, action: PayloadAction<Partial<ExpressionOfInterestState>>): ExpressionOfInterestState => {
            return {
                ...state,
                ...action.payload,
            };
        },
        resetExpressionOfInterest: (): ExpressionOfInterestState => {
            return {
                ...initialExpressionOfInterest,
            };
        },
    },
});

export const { setExpressionOfInterest, resetExpressionOfInterest } = expressionOfInterestSlice.actions;
export default expressionOfInterestSlice.reducer;
